import { useState } from "react";
import { Link } from "react-router-dom";
import { Flame, Eye } from "lucide-react";
import { Cover } from "./Bits";
import { pad } from "@/lib/api";

const Row = ({ r, kind }) => (
  <Link to={`/a/${r.artist.slug}`} data-testid={`chart-row-${kind}-${r.rank}`}
    className="group grid grid-cols-[48px_48px_1fr_auto] items-center gap-4 border-b border-white/5 px-3 py-3 transition-colors hover:bg-white/[.03] sm:grid-cols-[64px_56px_1fr_auto_auto]">
    <span className={`led text-2xl font-bold sm:text-3xl ${r.rank === 1 ? "!text-[#FF2E63]" : ""}`} style={r.rank === 1 ? { textShadow: "0 0 14px rgba(255,46,99,.7)" } : {}}>{pad(r.rank)}</span>
    <Cover src={r.cover} className="h-12 w-12 rounded-md" />
    <div className="min-w-0">
      <div className="truncate font-display font-bold group-hover:text-[#00F5D4]">{r.title}</div>
      <div className="truncate text-sm text-slate-400">{r.artist.stage_name} · {r.genre}</div>
    </div>
    <span className="hidden font-mono text-xs text-slate-500 sm:block">{r.plays} plays</span>
    <span className="flex items-center gap-1.5 font-mono text-sm text-[#FF2E63]"><Flame className="h-4 w-4" fill="currentColor" />{r.flames}</span>
  </Link>
);

export const ChartBoard = ({ data, limit = 10 }) => {
  const [tab, setTab] = useState("blind");
  const rows = (data?.[tab] || []).slice(0, limit);
  const tabCls = (t) => `flex-1 rounded-full px-4 py-2 font-mono text-[11px] uppercase tracking-widest transition-colors ${tab === t ? "bg-[#FF2E63] text-white" : "text-slate-400 hover:text-white"}`;
  return (
    <div className="panel console-corners scanline relative overflow-hidden" data-testid="chart-board">
      <div className="flex flex-col gap-4 border-b border-white/5 p-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex rounded-full border border-white/10 p-1">
          <button data-testid="chart-tab-blind" className={tabCls("blind")} onClick={() => setTab("blind")}><Eye className="mr-1 inline h-3 w-3" />Blind Chart</button>
          <button data-testid="chart-tab-fan" className={tabCls("fan")} onClick={() => setTab("fan")}><Flame className="mr-1 inline h-3 w-3" />Fan Chart</button>
        </div>
        <p className="text-xs text-slate-500">{tab === "blind" ? "Only Flames given while the artist name was hidden. Pure music." : "All Flames this week. Bring your fans, climb the board."}</p>
      </div>
      {rows.length ? rows.map((r) => <Row key={r.track_id} r={r} kind={tab} />) : <p className="p-8 text-center text-slate-500">No Flames yet this week. Be the first.</p>}
    </div>
  );
};
